// extracted by mini-css-extract-plugin
module.exports = {"mainButton":"button_mainButton__vw-n9","subButton":"button_subButton__1DKzz"};